var _filter, _linearGradient, _filter2, _linearGradient2, _g, _filter3, _filter4, _filter5, _filter6, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "master_svg0_960_011275/546_30550",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2,
    dx: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.10196078568696976 0 0 0 0 0.529411792755127 0 0 0 0 0.4745098054409027 0 0 0 0.20000000298023224 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    x1: -0.01696908473968506,
    y1: 1,
    x2: 0.8740648096600352,
    y2: -0.12729613258085337,
    id: "master_svg1_485_28493"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#55FF00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B2F6FF",
    stopOpacity: 1
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "master_svg2_960_011275/546_30552",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2,
    dx: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.08849557489156723 0 0 0 0 0.4166666567325592 0 0 0 0 0.37484118342399597 0 0 0 0.4000000059604645 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: -0.01696908473968506,
    y1: 1,
    x2: 0.8740648890199332,
    y2: -0.12729608640528833,
    id: "master_svg3_475_29586"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFFFFF",
    stopOpacity: 1
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "master_svg4_960_011275/546_30552",
    style: {
      maskType: "alpha"
    },
    maskUnits: "objectBoundingBox"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#master_svg2_960_011275/546_30552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.694708125,1.44933234375C12.934578125,1.35302734375,13.235378125,1.11914034375,13.800778125,0.67539799375Q13.974978125,0.67783864375,14.094678125,0.75987064375Q14.411578125,0.97706634375,14.345878125,1.73816734375C14.345678125,5.93760734375,10.986208125,12.25502734375,4.605938125,12.21522734375L4.4115481249999995,12.21242734375C3.551998125,12.19342734375,2.618565125,13.44762734375,2.833008125,15.34432734375C2.745108125,15.30012734375,2.275431125,14.83452734375,2.187500125,14.79012734375L1.642578125,13.71302734375C2.448462125,9.44110734375,5.564458125,7.06298734375,9.322268125,5.54540734375C6.189988125,5.81712734375,3.688508125,5.99733734375,2.187877125,9.15855734375C-0.30957187500000005,3.12998734375,8.454848125,1.54563634375,10.694708125,1.44933234375Z",
    fillRule: "evenodd",
    fill: "url(#master_svg3_475_29586)",
    fillOpacity: 1
  })))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "master_svg5_960_011275/546_30554",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.14089923957214617,
    y: -0.10977922372032983,
    width: 1.2817984791442922,
    height: 1.2195584474406596
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4000000059604645,
    result: "effect1_foregroundBlur"
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "master_svg6_960_011275/546_30555",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.20454432264844724,
    y: -0.19405424901268062,
    width: 1.4090886452968945,
    height: 1.3881084980253613
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4000000059604645,
    result: "effect1_foregroundBlur"
  }))), _filter5 || (_filter5 = /*#__PURE__*/React.createElement("filter", {
    id: "master_svg7_960_011275/546_30553",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.22116630999109915,
    y: -0.44439722565887424,
    width: 1.4423326199821982,
    height: 1.8887944513177484
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4000000059604645,
    result: "effect1_foregroundBlur"
  }))), _filter6 || (_filter6 = /*#__PURE__*/React.createElement("filter", {
    id: "master_svg8_960_011275/546_30556",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.16532161750235666,
    y: -0.2362168396770473,
    width: 1.3306432350047133,
    height: 1.4724336793540946
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#master_svg0_960_011275/546_30550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.694708125,1.4394613437500001C13.174278125,1.2773603437499998,13.347878125,1.02549534375,13.800778125,0.66552734375Q13.974978125,0.66796802375,14.094678125,0.75000004375Q14.411578125,0.96719634375,14.345878125,1.72829734375C14.345678125,5.92773734375,10.986208125,12.24522734375,4.605938125,12.20532734375L4.4115481249999995,12.20252734375C3.551998125,12.18352734375,2.618565125,13.43772734375,2.833008125,15.33442734375C2.745108125,15.29022734375,2.275431125,14.82462734375,2.187500125,14.78022734375L1.642578125,13.70312734375C2.448462125,9.43123734375,5.499998124999999,6.99999734375,9.499998125000001,5.49999734375C6.367728125,5.77171734375,3.688508125,5.98746734375,2.187877125,9.14868734375C-0.30957187500000005,3.12011734375,8.215168125,1.60156234375,10.694708125,1.4394613437500001Z",
    fillRule: "evenodd",
    fill: "url(#master_svg1_485_28493)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#master_svg4_960_011275/546_30552)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#master_svg5_960_011275/546_30554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.825498725,13.472684375Q2.547163125,14.602884375,2.645682125,15.365384375L2.943209125,15.326984375Q2.851882925,14.620084375,3.116795125,13.544384375Q3.391185125,12.430284375,3.737805125,12.430284375Q4.433543125,12.430284375,6.646573125,12.011184375L6.656193125,12.009284375L6.665483125,12.006284375Q11.300583125,10.483374375,13.236103125,6.122004375Q13.859203125,4.718084375,14.127403125,3.165894375Q14.282303125,2.269794375,14.282303125,1.671386375Q14.282303125,1.119637375,13.960103125,0.682484275L13.718603125,0.860484475Q13.982303125,1.218254375,13.982303125,1.671386375Q13.982303125,2.244054375,13.831803125,3.114804375Q13.569903125,4.630364375,12.961903125,6.000314375Q11.082333125,10.235554375,6.5811231249999995,11.718184375Q4.403913125,12.130284375,3.737805125,12.130284375Q3.156105125,12.130284375,2.825498725,13.472684375Z",
    fillRule: "evenodd",
    fill: "#E4FFFD",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#master_svg6_960_011275/546_30555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.7911831249999999,13.81385984375Q2.497388125,8.67165984375,9.523498125,5.68639584375L9.406188125,5.41028384375Q2.223340125,8.46213984375,1.4939731250000001,13.77304984375L1.7911831249999999,13.81385984375Z",
    fillRule: "evenodd",
    fill: "#E1FFF6",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#master_svg7_960_011275/546_30553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.450766250000001,5.3796634609375Q3.34784625,5.6349504609375,2.08187025,9.078147460937501L2.36344225,9.1816774609375Q3.56035625,5.9263314609375,9.463296249999999,5.6794014609375L9.450766250000001,5.3796634609375Z",
    fillRule: "evenodd",
    fill: "#E1FFF6",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#master_svg8_960_011275/546_30556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.698862825,5.5693859375Q0.977798125,7.2483959375,1.896570125,9.2348359375L2.350380125,9.0249359375Q0.808105125,5.6904559375,4.275338125,3.5132959375Q5.601918125,2.6803059375,7.421298125,2.1743559374999997Q8.969468124999999,1.7438259375,10.159438125,1.7167359375Q13.089478125,1.6500139375,13.907278125,0.8407839375L13.555578125,0.4853879375Q12.879278125,1.1546729375,10.148058125,1.2168619375Q8.895668125,1.2453779375,7.287338125,1.6926359375Q5.397748125,2.2181059375,4.0094481250000005,3.0898559375Q2.303744125,4.1609059375,1.698862825,5.5693859375Z",
    fillRule: "evenodd",
    fill: "#E1FFF6",
    fillOpacity: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.4fc6a1c3ca85730adcbf318fd7216e4a.svg";
export { ForwardRef as ReactComponent };